import { useCallback } from 'react';

import { useNavigate } from '@remix-run/react';

import { COMMUNITY_ROUTES } from '~/constants/community';

// Imperative counterpart to <PostLink>. Always sets state.fromInsideApp so the
// post page's back button can pop history; see PostDetailBackButton.
export const useNavigateToPost = () => {
  const navigate = useNavigate();

  return useCallback(
    (postId: string, options?: { hash?: string }) => {
      const path = options?.hash ? `${COMMUNITY_ROUTES.post(postId)}#${options.hash}` : COMMUNITY_ROUTES.post(postId);
      navigate(path, { state: { fromInsideApp: true } });
    },
    [navigate],
  );
};
